import React from 'react'
import styles from './TipsForSuccess.module.scss'
import JobSeekerHeading from '../JobSeekerHeading'

const TipsForSuccess = () => {
  return (
    <div className={styles.main}>
      <div className={`${styles.container} pb-5 `}>
        <div className={`${styles.inner} px-lg-5 px -sm-1 py-3`}>
          <JobSeekerHeading
            title="TIPS FOR SUCCESS"
            subHeading={[
              'These ',
              <span> five tips </span>,
              'are well worth remembering before you take an',
              <a href="https://www.practicereasoningtests.com//practice-aptitude-tests ">
                {' '}
                aptitude test{' '}
              </a>,
              'for real:',
            ]}
          />
          <div className={`${styles.clipboard}`}>
            <div>
              <img
                src="https://www.practicereasoningtests.com//wp-content/uploads/2017/05/clipboard.png"
                sizes="(max-width: 759px) 100vw, 759px"
                srcSet="https://www.practicereasoningtests.com//wp-content/uploads/2017/05/clipboard.png 759w, https://www.practicereasoningtests.com//wp-content/uploads/2017/05/clipboard-300x99.png 300w"
                alt="clipboard"
                width="759"
                height="251"
              />
            </div>
            <div className={`${styles.layout}`}>
              <div>
                <h6>1.</h6>
              </div>
              <div>
                <p>
                  Treat the{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    test
                  </a>{' '}
                  like you would any other exam.
                </p>
              </div>
            </div>
            <div className={`${styles.layout}`}>
              <div>
                <h6>2.</h6>
              </div>
              <div>
                <p>
                  Work swiftly and accurately through any{' '}
                  <a rel="nofollow" href="https://l.linklyhq.com/l/O0fY">
                    test
                  </a>
                  .
                </p>
              </div>
            </div>
            <div className={`${styles.layout}`}>
              <div>
                <h6>3.</h6>
              </div>
              <div>
                <p>
                  Work out the maximum time you can spend on any question and
                  stick to it religiously. You can return to questions at the
                  end. Never get stuck on any particular question, even if you
                  think you nearly have it.
                </p>
              </div>
            </div>
            <div className={`${styles.layout}`}>
              <div>
                <h6>4.</h6>
              </div>
              <div>
                <p>
                  If you are going to an assessment centre, take a calculator
                  you understand with you. If you do not, you will be forced to
                  use whatever they might provide you with.
                </p>
              </div>
            </div>
            <div className={`${styles.layout}`}>
              <div>
                <h6>5.</h6>
              </div>
              <div>
                <p>
                  Answer as many questions as possible in the time given. But be
                  wary of negative marking.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default TipsForSuccess
